import type { BodyCompositionPayload } from "@medassist/shared";
import { BODY_METRICS } from "@medassist/shared";
import { CameraIcon } from "../../icons.js";
import { relativeTime } from "../../../lib/time.js";
import type { WidgetProps } from "../types.js";

const PREVIEW_IDS = ["bodyFatPct", "leanMassPct", "bmi"];

export function BodyWidget({ events, onNavigate }: WidgetProps) {
  const entries = events.filter((e) => e.eventType === "body_composition");
  const latest = entries[0];
  const payload = latest?.payload as unknown as BodyCompositionPayload | undefined;

  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <div className="mb-2 flex items-center gap-2">
        <CameraIcon size={16} className="text-(--accent)" />
        <h2 className="font-semibold text-gray-900 dark:text-gray-100">Body composition</h2>
        <button onClick={() => onNavigate("body")} className="ml-auto text-xs text-(--accent) hover:underline">
          View
        </button>
      </div>
      {latest && payload ? (
        <>
          <p className="mb-2 text-xs text-gray-400 dark:text-gray-500">{relativeTime(latest.occurredAt)}</p>
          <div className="space-y-1">
            {PREVIEW_IDS.map((id) => {
              const meta = BODY_METRICS.find((m) => m.id === id);
              const metric = payload.metrics?.[id];
              if (!metric) return null;
              return (
                <div key={id} className="flex items-center justify-between text-sm">
                  <span className="text-gray-600 dark:text-gray-400">{meta?.label ?? id}</span>
                  <span className="font-medium text-gray-900 dark:text-gray-100">
                    {metric.value.toFixed(1)}{meta?.unit ? ` ${meta.unit}` : ""}
                  </span>
                </div>
              );
            })}
          </div>
          <p className="mt-2 text-xs text-gray-400 dark:text-gray-500">{entries.length} entr{entries.length === 1 ? "y" : "ies"}</p>
        </>
      ) : (
        <p className="text-sm text-gray-400 dark:text-gray-500">No body composition entries yet</p>
      )}
    </section>
  );
}
